import CatalogObjectSerializer from '@square/dashboard-items-data/serializers/connect/catalog-object';
export default class ItemVariationVendorInfo extends CatalogObjectSerializer {}